export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-array/src/constant.js
// module id = eFvz
// module chunks = 0